import { getDimensionValue, getDimensionUniqueValues, getMeasureValues, getHigherDimensionValues } from "./helper";
import { DatapointValueTypeEnum } from "api/ux/src";
const addLeafItem = (higherDimensionValues, currentDimension, currentDimensionValue, measuresValues, date, options) => {
    const measures = {};
    measuresValues.forEach((m) => {
        if (m) {
            measures[m.name] = m.value;
        }
    });
    const item = {
        dimension: currentDimensionValue
    };
    if (!options?.flyWeight) {
        item.date = date;
        higherDimensionValues.forEach((hdv) => {
            if (hdv) {
                measures[hdv.name] = hdv.value;
            }
        });
        if (currentDimension.name) {
            measures[currentDimension.name] = currentDimensionValue;
        }
    }
    item.measures = measures;
    return item;
};
const setLeafIfFound = (action, s, higherDimensionValues, measures, dimension, options) => {
    // All higher dimensions' values match for current series => keep
    const currentDimension = getDimensionValue(s, dimension);
    if (currentDimension?.value) {
        const measuresValues = getMeasureValues(s.datapoints?.filter((d) => measures.includes(d?.name || "")));
        if (measuresValues && measuresValues.length) {
            action(addLeafItem(higherDimensionValues, currentDimension, currentDimension.value, measuresValues, s.date, options));
        }
    }
};
const getTotalCompositeMeasureObject = (composite, measures, totals, options) => {
    const result = { data: composite };
    if (options?.isSprout || (totals && totals.length > 1)) {
        return composite;
    }
    else if (totals?.length === 1) {
        // Totals?.length === 1 means only the overall total is left
        const [total] = totals;
        const measuresValues = getMeasureValues(total.datapoints?.filter((d) => measures.includes(d?.name || "")));
        if (measuresValues && measuresValues.length) {
            const dummyDimension = { name: "", type: DatapointValueTypeEnum.String };
            const leaf = addLeafItem([], dummyDimension, "", measuresValues, total.date, options);
            result.measures = leaf.measures;
        }
    }
    return [result];
};
export const getLeafCompositeMeasuresObject = (series, higherDimensionsFilters, measures, dimension, options) => {
    if (series.length < 1) {
        return [];
    }
    const ltg = Object.keys(higherDimensionsFilters)?.length;
    const result = [];
    series.forEach((s) => {
        if (s && s.date) {
            const higherDimensionValues = getHigherDimensionValues(s, higherDimensionsFilters);
            if (higherDimensionValues.length === ltg) {
                setLeafIfFound((leaf) => {
                    result.push(leaf);
                }, s, higherDimensionValues, measures, dimension, options);
            }
        }
    });
    return result;
};
export const getCompositeMeasuresObject = (series, higherDimensionsFilters, measures, dimensions, totals, options) => {
    if (series.length < 1 || dimensions.length < 1) {
        return [];
    }
    if (dimensions.length === 1) {
        const [soleDimension] = dimensions, leafs = getLeafCompositeMeasuresObject(series, higherDimensionsFilters, measures, soleDimension, options);
        return Object.keys(higherDimensionsFilters).length ? leafs : getTotalCompositeMeasureObject(leafs, measures, totals, options);
    }
    const [nextDimensionName, ...nextDimensions] = dimensions, { uniqueDimensions: nextDimensionValues, seriesWithDimensionLookup } = getDimensionUniqueValues(series, nextDimensionName, higherDimensionsFilters);
    const composite = nextDimensionValues.map((ndv) => {
        const cumulatedHigherDimensionsFilters = { ...higherDimensionsFilters }, result = { dimension: ndv };
        let totalIndex = -1;
        cumulatedHigherDimensionsFilters[nextDimensionName] = ndv;
        result.data = getCompositeMeasuresObject(seriesWithDimensionLookup[ndv], cumulatedHigherDimensionsFilters, measures, nextDimensions, totals, { ...options, isSprout: true });
        let exitDoorIfLeafFound = false;
        totals?.forEach((total, index) => {
            if (exitDoorIfLeafFound) {
                return;
            }
            const hdvs = getHigherDimensionValues(total, cumulatedHigherDimensionsFilters);
            if (hdvs.length === Object.keys(cumulatedHigherDimensionsFilters).length) {
                setLeafIfFound((leaf) => {
                    result.measures = leaf.measures;
                }, total, hdvs, measures, nextDimensionName, options);
                totalIndex = index;
                exitDoorIfLeafFound = true;
            }
        });
        if (totalIndex >= 0) {
            // It is important to keep the same array reference, that's why we use splice
            totals?.splice(totalIndex, 1);
        }
        return result;
    });
    return getTotalCompositeMeasureObject(composite, measures, totals, options);
};
